import script from "./roleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./roleDetail.vue?vue&type=script&setup=true&lang=js"

import "./roleDetail.vue?vue&type=style&index=0&id=fa5e503a&lang=less"

const __exports__ = script;

export default __exports__